<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="26.709" height="26.709" viewBox="0 0 26.709 26.709"><g transform="translate(-503 -183.188)"><path d="M516.354,183.188a13.355,13.355,0,1,0,13.354,13.354A13.359,13.359,0,0,0,516.354,183.188Zm0,24.038a10.684,10.684,0,1,1,10.684-10.684A10.7,10.7,0,0,1,516.354,207.226Z" fill="#ba961a"/><path d="M513.968,187H511v2.968h2.968Zm0,5.935H511v8.9h2.968Z" transform="translate(3.871 1.844)" fill="#ba961a"/></g></svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'info'
}
</script>
